module.exports = __webpack_public_path__ + "img/letrero_Infografias.fb4dd2ad.jpeg";